export class Step {
    id: string;
    label: string;
    route: string;
    completed: boolean;
    disabled: boolean;
    index?: number
}
